import { Typography } from '@mui/material/styles/createTypography';

export default <Typography>{
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Inter var"',
    '"Segoe UI"',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  fontWeightRegular: 400,
  fontWeightBold: 500,
  h1: {
    fontSize: '2rem',
    lineHeight: 1.2,
    fontWeight: 500,
    letterSpacing: '-0.24px',
  },
  h2: {
    fontSize: '1.5rem',
    lineHeight: 1.33,
    fontWeight: 500,
    letterSpacing: '-0.24px',
  },
  h3: {
    fontSize: '1.125rem',
    lineHeight: 1.4,
    fontWeight: 500,
    letterSpacing: '-0.06px',
  },
  h4: {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: '150%',
  },
  h5: {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '150%',
  },
  h6: {
    fontWeight: 500,
    fontSize: '0.8125rem',
    lineHeight: 1.4,
  },
  body1: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    fontWeight: 400,
  },
  body2: {
    fontWeight: 400,
    fontSize: '0.8125rem',
    lineHeight: 1.4,
  },
  caption: {
    fontSize: '0.8rem',
    lineHeight: 1.4,
  },
  subtitle1: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    fontWeight: 500,
  },
  subtitle2: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
  },
  button: {
    fontWeight: 500,
    letterSpacing: '0.025em',
  },
};
